import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdmAuthAPI } from "../api";

export default function AdmLogin() {
  const [id, setId] = useState("");
  const [password, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!id.trim() || !password.trim()) { setErr("아이디/비밀번호를 입력하세요."); return; }
    setLoading(true); setErr("");
    try {
      const { token } = await AdmAuthAPI.login({ id, password });
      localStorage.setItem("adm_token", token);
      nav("/adm/branch", { replace: true });
    } catch (e) { setErr(e?.message || "로그인 실패"); }
    finally { setLoading(false); }
  };

  return (
    <section className="adm-login">
      <div className="adm-login-cont">
        <h2>관리자 로그인</h2>
        <form onSubmit={onSubmit}>
          <input placeholder="아이디" value={id} onChange={e=>setId(e.target.value)} />
          <input type="password" placeholder="비밀번호" value={password} onChange={e=>setPw(e.target.value)} />
          <button className="btn" disabled={loading}>{loading ? "로그인 중…" : "로그인"}</button>
          {err && <p className="error">{err}</p>}
        </form>
      </div>
    </section>
  );
}
